import Vue from 'vue'
import { addGA } from '@/utils/assist'
import { updateConsentGA } from '@/utils/eu_popup'
export default new Vue({
  data () {
    return {
      uid: null,
      gems: 0,
      transify: {
        COMMON_BACK: 'back',
        COMMON_CANCEL: 'cancel',
        COMMON_CONFIRM: 'confirm',
        COMMON_CONTINUE_PURCHASE: 'continue to buy',
        COMMON_HISTORY_DRAW: '',
        COMMON_HISTORY_PURCHASE: '',
        COMMON_HISTORY_REDEEM: '',
        COMMON_NO: 'no',
        COMMON_PURCHASE: 'purchase',
        COMMON_PURCHASED: 'purchased',
        COMMON_QUANTITY_MAX: 'max',
        COMMON_TIPS_ITEM: 'the rewards will be sent directly to your vault',
        COMMON_YES: 'Yes',
        POPUP_NO_REMIND: '', // 需要默认值
        POPUP_TITLE_REDEEM: 'Congratulation! You got',
        POPUP_TITLE_UNIQUE: 'The unique items you owe',
        UNIQUE_BUY_ALREADY_HAVE:
          'You already own this item, if you purchase it again, it will be converted to FF tokens.',
        UNIQUE_BUY_ALREADY_HAVE_PART:
          'You already owe some of the item(s) you selected. If you purchase again, you will receive FF tokens instead.',
        UNIQUE_REDEEM_ALREADY_HAVE:
          'You already own this item, if you receive it again, it will be converted to FF tokens.',
        TOAST_ERROR_CODE: 'unknown error, error code {code}',
        TOAST_EVENT_CLOSED_AWHILE: 'The event is closed temporary',
        TOAST_EVENT_END: 'Event ended',
        TOAST_EVENT_NOTOPEN: "event hasn't started",
        TOAST_GEM_NOT_ENOUGH: 'insufficient diamonds, please top up and come back again',
        TOAST_LOGIN_FAILED: 'login failed',
        TOAST_NETWORK_BUSY: 'Server busy, please try again later',
        TOAST_NETWORK_ERROR: 'Network connection error, please try again later',
        TOAST_OPERATE_BUSY: 'Too many requests, please try again later',
        TOAST_PAY_FAILED: 'purchase failed',
        TOAST_SERVER_BUSY: '',
        TOAST_SERVER_NOTWORK: 'service unavailable',
        TOAST_SERVER_TIMEOUT: 'service timeout',
        TOAST_WRONG_REGION: 'This event is not available for your region'
      },

      // dialog
      ruleDialogContent: '',
      ruleDialogShow: false,

      historyDialogShow: false,
      historyDialogList: [],

      spendDialogShow: false,

      discountDialogShow: false,

      toast: {
        show: false,
        content: '',
        // 是否可以关闭，默认可以关闭
        closeable: true
      },

      loading: {
        show: false,
        opacity: false
      },

      // 基础折扣
      discount: [],

      // 是否第一次进入活动
      isFirst: false,

      // character component
      expand: true,
      dialogCharacterText: '',
      // NOTE 记录对话状态 ---> 'base' 'welcome' 'purchase' 'ticket' 'bigDiscount' 'all'
      dialogCharacterTextStatus: '',

      // shop component
      discountText: '',
      shopType: 'food', // shopType ---> food fishing shoot
      shop: [],
      shopFood: [],
      shopFishing: [],
      shopShoot: [],
      prize: {}, // 当前奖品
      currentDiscount: 100, // 当前折扣
      currentCost: 0, // 当前耗钻
      costLimit: [],
      cost: [], // 三个shop的耗钻量
      bigDiscount: [],
      ticketBgMarkFlag: false, // 是否到达抽大折扣条件
      inusefood: false,
      inusefishing: false,
      inuseshoot: false,
      activeIndex: -1,
      useBig: [{}, {}, {}],
      timer: null,
      alertShow: false,
      alertTitle: '',
      alertContent: ''
    }
  },
  methods: {
    updateConsentGA,
    checkGem (price) {
      return this.gems >= price
    },
    /**
     * 错误处理
     * @param {String} errCode 错误码
     * @return toast | dialog 组件
     */
    handleError (data, closeable = true) {
      let code = typeof data === 'string' ? data : data.code
      closeable = typeof data === 'string' ? closeable : data.closeable
      addGA('msgError', code)
      let message =
        this.transify[code] || ((closeable = false), this.transify['TOAST_NETWORK_ERROR'])
      if (code === 'TOAST_NETWORK_ERROR') closeable = false
      // closeable ? this.$toast(message, 2000, true) : this.$message(message, closeable)
      this.toast.show = true
      this.toast.content = message
      this.toast.closeable = closeable
    },
    // 替换 `{}`
    replaceText (source, target) {
      const reg = /\{(.+?)\}/
      return source ? source.replace(reg, target) : ''
    },
    // 获取 shopType 对应的 discount
    mapShopTypeToDiscount (shopType) {
      switch (shopType) {
        case 'food':
          return 0
        case 'fishing':
          return 1
        case 'shoot':
          return 2
        default:
          return -1
      }
    },
    // 获取 shopType 对应的 shopName
    mapShopTypeToShopName () {
      const { shopType } = this
      switch (shopType) {
        case 'food':
          return this.transify['FESTA_SHOP_A'] ? this.transify['FESTA_SHOP_A'] : 'FESTA_SHOP_A'
        case 'fishing':
          return this.transify['FESTA_SHOP_B'] ? this.transify['FESTA_SHOP_B'] : 'FESTA_SHOP_B'
        case 'shoot':
          return this.transify['FESTA_SHOP_C'] ? this.transify['FESTA_SHOP_C'] : 'FESTA_SHOP_C'
        default:
          return ''
      }
    },
    mapShopIndexToShopType (index) {
      switch (index) {
        case 0:
          return 'food'
        case 1:
          return 'fishing'
        case 2:
          return 'shoot'
        default:
          return ''
      }
    },
    mapShopIndexToShopName (index) {
      switch (index) {
        case 0:
          return this.transify['FESTA_SHOP_A'] ? this.transify['FESTA_SHOP_A'] : 'FESTA_SHOP_A'
        case 1:
          return this.transify['FESTA_SHOP_B'] ? this.transify['FESTA_SHOP_B'] : 'FESTA_SHOP_B'
        case 2:
          return this.transify['FESTA_SHOP_C'] ? this.transify['FESTA_SHOP_C'] : 'FESTA_SHOP_C'
        default:
          return ''
      }
    },
    // 更新 dialogCharacterText
    updateDialogCharacterText () {
      this.expand = true
      const status = this.dialogCharacterTextStatus
      if (status === 'base') {
        this.dialogCharacterText = this.transify['FESTA_HINT_1'] ? this.transify['FESTA_HINT_1'] : 'FESTA_HINT_1'
      } else if (status === 'welcomefood') {
        let currentText = this.replaceText(this.transify['FESTA_HINT_2'], this.mapShopTypeToShopName())
        if (!currentText) {
          currentText = 'FESTA_HINT_2'
        }
        this.dialogCharacterText = currentText
      } else if (status === 'welcomefishing') {
        let currentText = this.replaceText(this.transify['FESTA_HINT_2'], this.mapShopTypeToShopName())
        if (!currentText) {
          currentText = 'FESTA_HINT_2'
        }
        this.dialogCharacterText = currentText
      } else if (status === 'welcomeshoot') {
        let currentText = this.replaceText(this.transify['FESTA_HINT_2'], this.mapShopTypeToShopName())
        if (!currentText) {
          currentText = 'FESTA_HINT_2'
        }
        this.dialogCharacterText = currentText
      } else if (status === 'purchase') {
        this.dialogCharacterText = this.transify['FESTA_HINT_3'] ? this.transify['FESTA_HINT_3'] : 'FESTA_HINT_3'
      } else if (status === 'ticket') {
        this.dialogCharacterText = this.transify['FESTA_HINT_4'] ? this.transify['FESTA_HINT_4'] : 'FESTA_HINT_4'
      } else if (status === 'bigDiscount') {
        this.dialogCharacterText = this.transify['FESTA_HINT_5'] ? this.transify['FESTA_HINT_5'] : 'FESTA_HINT_5'
      } else if (status === 'all') {
        this.dialogCharacterText = this.transify['FESTA_HINT_6'] ? this.transify['FESTA_HINT_6'] : 'FESTA_HINT_6'
      }
    },
    // sort list by bought
    sortListByPk (shop, pkList = [], shopIndex) {
      const newShop = []
      const newBoughtShop = []

      pkList.forEach(pk => {
        const item = shop.find(item => item.pk === pk)
        item.bought = true
        if (this.useBig[shopIndex][pk]) {
          item.bigBoughtDiscount = this.useBig[shopIndex][pk]
        }
        newBoughtShop.push(item)
      })

      shop.forEach(item => {
        const newItem = {...item}
        const pk = item.pk
        if (!pkList.includes(pk)) {
          newItem.bought = false
          newShop.push(newItem)
        }
      })

      return [...newShop, ...newBoughtShop]
    },
    // 将数组指定元素移动到数组末尾
    moveItemToEnd (shop, pk) {
      const shopIndex = this.mapShopTypeToDiscount(this.shopType)
      const len = shop.length
      const index = shop.findIndex(item => item.pk === pk)
      shop[index].bought = true
      // 判断是否是通过大折扣购买
      if (this.useBig[shopIndex][pk]) {
        shop[index].bigBoughtDiscount = this.useBig[shopIndex][pk]
      }
      const item = shop.splice(index, 1)
      shop.splice(len - 1, 0, item[0])
    },
    // 更新shop
    updateShop (pk) {
      const index = this.mapShopTypeToDiscount(this.shopType)
      if (index === 0) {
        this.moveItemToEnd(this.shopFood, pk)
      } else if (index === 1) {
        this.moveItemToEnd(this.shopFishing, pk)
      } else if (index === 2) {
        this.moveItemToEnd(this.shopShoot, pk)
      }
    },
    flat (arr) {
      return [].concat(...arr)
    },
    // merge list by given key
    mergeList (target, key) {
      if (!target || !target.length) {
        return []
      }
      const newSource = this.flat(this.shop)
      return target.map(element => ({
        ...newSource.find(item => item[key] === element[key]),
        ...element
      }))
    },
    // 判断是否购买全部商品
    isPurchaseAll () {
      const currentShop = this[`shop${this.lowerCaseStr(this.shopType)}`]
      return currentShop.every(item => item.bought === true)
    },
    // 首字母大写
    lowerCaseStr (str) {
      return str.slice(0, 1).toUpperCase() + str.slice(1).toLowerCase()
    }
  }
})



// WEBPACK FOOTER //
// ./src/bus/index.js